exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ShowBreakingNews__root--WJk-T {\n  z-index: 3;\n  position: fixed;\n}", ""]);

// exports
exports.locals = {
	"root": "ShowBreakingNews__root--WJk-T"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };